/**
 * Logging level.
 */
export enum TeacherGroup {
  MANAGER = 'manager'
}
